import React from "react";
import SummaryCard from "./SummaryCard";
import { getComplianceNameById } from "./summaryHelpers";
import { AdditionalInformationFormInput } from "../AdditionalInformation.types";
import { ComplianceData } from "../SetBacksInspectionForm.types";

type Props = {
    data?: AdditionalInformationFormInput;
    complianceData?: ComplianceData[];
};

const AdditionalInformationReadOnly: React.FC<Props> = ({ data, complianceData }) => {
    if (!data) return null;
    return (
        <SummaryCard
            title={
                <>
                    <svg className="me-2" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="8"/></svg>
                    Additional Information
                </>
            }
        >
            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.unobstructedAreaComplianceId)}</label>
                </div>
                <div className="col col-md-4">
                    <label> {"Unobstructed Area"}</label>
                </div>
            </div>
            {(data as any)?.unobstructedAreaCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <label>{data?.unobstructedAreaComment}</label>
                </div>
            ) : null}

            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.stormwaterRunoffComplianceId)}</label>
                </div>
                <div className="col col-md-4">
                    <label> {"Stormwater/Roof Runoff"}</label>
                </div>
            </div>
            {(data as any)?.stormwaterRunoffCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <label>{data?.stormwaterRunoffComment}</label>
                </div>
            ) : null}

            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.alarmComplianceId)}</label>
                </div>
                <div className="col col-md-4">
                    <label> {"Alarms"}</label>
                </div>
            </div>
            {(data as any)?.alarmCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <label>{data?.alarmComment}</label>
                </div>
            ) : null}

            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.supportDocumentComplianceId)}</label>
                </div>
                <div className="col col-md-4">
                    <label> {"Supporting Documentation"}</label>
                </div>
            </div>
            {(data as any)?.supportDocumentCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <label>{data?.supportDocumentnComment}</label>
                </div>
            ) : null}

            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.buildingAreaComplianceId)}</label>
                </div>
                <div className="col col-md-4">
                    <label> {"Building Area"}</label>
                </div>
            </div>
            {(data as any)?.buildingAreaCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <label>{data?.buildingAreaComment}</label>
                </div>
            ) : null}

            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.locationConformsComplianceId)}</label>
                </div>
                <div className="col col-md-4">
                    <label> {"Compliance with Site Plan"}</label>
                </div>
            </div>
            {(data as any)?.locationConformsCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <label>{data?.locationConformsComment}</label>
                </div>
            ) : null}

            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.finalSiteGradeComplianceId)}</label>
                </div>
                <div className="col col-md-4">
                    <label> {"Final Site Grading"}</label>
                </div>
            </div>
            {(data as any)?.finalSiteGradeCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <label>{data?.finalSiteGradeComment}</label>
                </div>
            ) : null}

            <div className="row mb-3">
                <div className="col col-md-4">
                    <label>{getComplianceNameById(complianceData as any, (data as any)?.contractorComplianceId)}</label>
                </div>
                <div className="col col-md-4">
                    <label> Contractor</label>
                    {data?.ehdcontactName && (
                        <span className="print-value">{` (${data?.ehdcontactName})`}</span>
                    )}
                </div>
            </div>
            {(data as any)?.contractorCompliance?.complianceValue === "Out of Compliance" ? (
                <div className="row mb-3">
                    <label>{data?.contractorComment}</label>
                </div>
            ) : null}


        </SummaryCard>
    );
};

export default AdditionalInformationReadOnly;


